module.exports = __webpack_public_path__ + "static/IA-fedfb560e0b6e93c2283bf4f98aae742.svg";